// DO NOT EDIT -- generated from fs/cook/cook.proto

import * as clientapi from '../services/recorder/clientapi';
import * as cookerr from './cookerr';
import * as protobuf from '../../google/protobuf';
import * as schema from '../shared/schema';
import * as selectors from '../selectors';
import * as vars from '../api/vars';

export interface Page {
  resources: PageResources | null;
  static: PageStaticFields | null;
  derived: DerivedData | null;
  cookMetadata: PageCookMetadata | null;
}

/**
 * Cook products output; a strict subset of the fields in Page, but for historical reasons
 * the individual fields do not perfectly overlap the decomposed messages in Page, so they're
 * all pushed up to the outer message here.
 */
export interface Products {
  /** From PageStaticFields. */
  args: schema.PageArgsProto | null;
  userCreatedAt: protobuf.timestamp | null;
  appData: PageAppData | null;
  webData: PageWebData | null;
  deviceData: PageDeviceData | null;
  /** From DerivedData. */
  eventsList: EventsList | null;
  duration: protobuf.duration | null;
  deadSpaces: PageDeadSpace[];
  closed: boolean;
  isInternalScrolling: boolean;
  lifecycleStates: schema.PageLifecycleTransition[];
  rawEventsTruncated: boolean;
  /** From PageResources. */
  resourceRoots: { [key: string]: PageResourceRoots };
  resourceUploads: { [key: string]: string };
  /** Per-page cook "complexity" metrics. */
  totalNodeCount: protobuf.int64;
  totalTextSize: protobuf.int64;
  totalDroppedNodeCount: protobuf.int64;
  totalWatchedElementCount: protobuf.int64;
  totalPolyfilledRootCount: protobuf.int64;
  /** overrides from event stream (SET_FRAME_BASE) */
  url: string;
  referrer: string;
  /** client-set document vars, set such asset-map-id for uploaded resources */
  documentVars: { [key: string]: string };
  /**
   * This field is completly usused right and we don't have any plans to use it in the future
   * 
   * @deprecated
   */
  tabId: string;
}

/**
 * Mobile app frameworks at play in recorded application.
 * This schema must be kept in sync with flatbuffer definitions; if this
 * changes, change nativemobile/flat/session.fbs as well!
 */
export enum DetectedMobileFrameworks {
  REACT_NATIVE = 0,
  FLUTTER = 1,
  CORDOVA = 2,
  IONIC = 3,
  SWIFTUI = 4,
  JETPACK_COMPOSE = 5,
  CAPACITOR = 6,
  FABRIC = 7
}

export enum BundleStorageType {
  /**
   * Deprecated option.
   * 
   * @deprecated
   */
  DEFAULT = 0,
  /** The default BigTable storage location, where all bundles go. */
  FS_KEEP = 1
}

/** Geo location determined by the corresponding ip address. */
export interface PageLocation {
  ipAddress: string;
  country: string;
  region: string;
  city: string;
  /** format "<lat>,<long>" */
  latLong: string;
}

/** Raw, important page headers. */
export interface PageHeaders {
  acceptLanguage: string;
  userAgent: string;
  /** Possibly-redacted referrer, as present in the /rec/page request.  Generally should NOT be used; see DerivedData.referrer instead. */
  referrer: string;
}

/** App specific information. */
export interface PageAppData {
  /** application version string */
  version: string;
  /** application package string */
  packageName: string;
  /** application display string */
  name: string;
  /** application build variant */
  buildType: string;
  /** application fs instrumentation version */
  fsVersion: string;
  /** application fs build id */
  fsBuildId: string;
  /** whether an app has enabled stable selectors for SwiftUI / Compose */
  stableSelectors: boolean;
  /** detected frameworks for mobile cook */
  detectedMobileFrameworks: DetectedMobileFrameworks[];
}

/** Web specific information. */
export interface PageWebData {
  compiledTimestamp: protobuf.timestamp | null;
  compiledVersion: string;
}

/** Device and OS specific information. */
export interface PageDeviceData {
  /** operating system version string */
  osVersion: string;
  /** operating system product id */
  osProduct: string;
  /** device model */
  model: string;
  /** device manufacturer */
  manufacturer: string;
  /** device display type (DPI and any other general info besides resolution) */
  displayType: string;
  /** device serial number */
  serial: string;
  /** device feature list */
  features: string[];
}

/** Sizes relevant to the page or device. */
export interface PageSizes {
  /** js screen size */
  screenSize: Size | null;
  /** initial viewport size */
  viewportSize: Size | null;
}

/** Resources contained within a page. */
export interface PageResources {
  /** map from original resource URL to GCS-cached URL (as determined by the resource crawl) */
  resources: { [key: string]: string };
  /** map from base url to all resources relative to that url (as determined by the cook) */
  resourceRoots: { [key: string]: PageResourceRoots };
  /** size-limited map from resource URL to errno for failed fetches (as determined by the resource crawl) TODO(ianrose): use proto enum */
  resourceFailures: { [key: string]: number };
  /** resources uploaded from client, hashed with fnv (as determined by the cook) */
  resourceUploads: { [key: string]: string };
  /** Count of entries dropped from the resources map due to the map exceeding max size. (as determined by the resource crawl) */
  overmaxResources: number;
  /** client-set document vars, set such asset-map-id for uploaded resources (as determine by the cook) */
  documentVars: { [key: string]: string };
}

/** Resources (URLs) that are reachable directly from the DOM. */
export interface PageResourceRoots {
  /** css to be preloaded and fetched */
  css: string[];
  /** imgs to be preloaded and fetched */
  imgs: string[];
  /** css to be fetched, but not preloaded */
  fetchOnlyCss: string[];
  /** imgs to be fetched, but not preloaded */
  fetchOnlyImgs: string[];
  /** non-fetched URLs (<video>, <iframe>, etc) */
  references: string[];
}

/** Single dead space contained within a page. */
export interface PageDeadSpace {
  /** offset in millis from the start of the page */
  startOffset: protobuf.int64;
  /** offset in millis from the start of the page */
  endOffset: protobuf.int64;
}

/**
 * Static fields, known from the very start of each page recording.
 * NB: While these are intended to be static, certain fields that are derived through external means such as the IP &
 * other location data may change between bundles.
 */
export interface PageStaticFields {
  type: schema.PageType;
  /**
   * todo (sehej) - remove once we stop depending on these args throughout stack
   * 
   * @deprecated
   */
  args: schema.PageArgsProto | null;
  /** Possibly-redacted page URL, as present in the /rec/page request. Generally should NOT be used; see DerivedData.page_url instead. */
  url: string;
  /** Base URL: https://developer.mozilla.org/en-US/docs/Web/API/Node/baseURI#the_base_url_of_a_document */
  baseUrl: string;
  /** geographic location, derived from ip address at recording */
  location: PageLocation | null;
  /** important page headers */
  headers: PageHeaders | null;
  sizes: PageSizes | null;
  sessionStartAt: protobuf.timestamp | null;
  pageStartAt: protobuf.timestamp | null;
  userCreatedAt: protobuf.timestamp | null;
  /** data about the built and fs-instrumented application */
  appData: PageAppData | null;
  /** data about the fs.js compiled script */
  webData: PageWebData | null;
  /** data about the device the application is running on */
  deviceData: PageDeviceData | null;
  preroll: protobuf.duration | null;
  doctype: string;
  /** currently native-mobile-only */
  buildId: string;
  /** Signals this is the first page in the session */
  isEntryPage: boolean;
  /** Web-only identifier for the page's browser tab. */
  tabId: string;
  /** Is this synthetic test traffic */
  isSynthetic: boolean;
  /**
   * All bundles move through the FS.Keep Pipeline.
   * 
   * @deprecated
   */
  bundleStorage: BundleStorageType;
  /** If FS.Focus Preview Mode is enabled then we should cook and index any prepped keep signal events. */
  isFsKeepPreviewMode: boolean;
  /** If Preview Mode is enabled */
  isPreviewMode: boolean;
  /**
   * Indicates that this is a page with no recording (i.e., it was on an unsupported browser)
   * todo(sehej) - (Nov 2020) fs.js no longer supports hail mary, deprecate this once we see no occurrences
   */
  fallback: boolean;
  /** Indicates that this page is from a server-only session (no client-side recording) */
  isServerSession: boolean;
  /**
   * Indicates if the parent session for this page is tagged with a customer-provided ID. If unset, the parent session
   * is not tagged.
   */
  sessionCustomUid: string;
  /**
   * The client generated session ID for this page in the form "user_uuid:session_uuid". Not populated if
   * not sent via stateless capture
   */
  clientSessionId: string;
  /** Indicates that this page is being streaming cooked on every received bundle */
  isStreaming: boolean;
  /** A client generated "password"; allows the session to be shared beyond ordinary "view playback" permissions. */
  sessionKeyHash: string;
  /** A client generated "password"; allows the page to be shared beyond ordinary "view playback" permissions. */
  pageKeyHash: string;
}

export interface Event {
  type: EventType;
  loadDetails?: EventLoadDetails | null;
  requestDetails?: EventRequestDetails | null;
  customDetails?: EventCustomDetails | null;
  uservarDetails?: EventUservarDetails | null;
  lowMemoryDetails?: EventLowMemoryDetails | null;
  pagevarDetails?: EventPageVarDetails | null;
  pinchGestureDetails?: EventPinchGestureDetails | null;
  exceptionDetails?: EventExceptionDetails | null;
  navigateDetails?: EventNavigateDetails | null;
  datalossDetails?: EventDatalossDetails | null;
  watchedElementDetails?: EventWatchedElementDetails | null;
  pageViewDetails?: EventPageViewDetails | null;
  consoleMessageDetails?: EventConsoleMessageDetails | null;
  consentDetails?: EventConsentDetails | null;
  fidDetails?: EventFirstInputDelayDetails | null;
  clsDetails?: EventCumulativeLayoutShiftDetails | null;
  keepDetails?: EventKeep | null;
  appRestartDetails?: EventAppForcedRestartDetails | null;
  inpDetails?: EventInteractionToNextPaintDetails | null;
  suspiciousActivityDetails?: EventSuspiciousActivityDetails | null;
  /**
   * The id of the frame that the result was generated within. The root frame will have a frame_id of 0.
   * Children frames (e.g. iFrames on web or webviews on NM) will have frame_id's greater than 0.
   * WARNING: frame_id's are not unique across frames. If you want a unique identifier, you must concat
   * the frame_id to the parent_ids.
   */
  frameId: number;
  /**
   * A list of the parent frame ids for the frame this event occurred within. The id at index i is the parent of index
   * i+1. The last id in the array is the parent of the current frame_id. The root frame will have no parent ids.
   * Likewise, a child frame of the root frame will have no parent ids (0 is implied)
   */
  parentIds: number[];
  /** android view id */
  viewId: protobuf.uint64;
  /** title of the page when the event occurred */
  pageTitle: string;
  /** url at the moment the event occurred */
  pageUrl: string;
  /** screen name at the moment the event occurred (mobile apps only) */
  appScreenName: string;
  /**
   * Whether or not the event should be redacted.
   * During the cook process, any extractor can set this flag to have the event removed from
   * the final cooked product. This allows us to emit all events for cooking but determine a different
   * redaction outcome during the cook process if we learn something new.
   */
  redacted: boolean;
  /** the target of the event */
  target: EventTarget | null;
  /** console statistics */
  consoleStats: EventConsoleStats | null;
  /** viewport sizes at the time of the event */
  viewportSize: Size | null;
  /** user specific variables */
  userVars: vars.Var[];
  /** modifiers added during the cook process with enum value keys (See EventModifier) and optional numeric values */
  modifiers: { [key: string]: number };
  /** bitfield used to set diagnostic metadata associated with an event */
  eventDiagnosticMetadata: protobuf.int64;
  /** when the event occurred, offset in millis since the start of the page */
  occurredOffset: protobuf.int64;
  /**
   * This is set during precooking to match an event's index in the prepped event list.  The value is carried through
   * to the cooked events and used during post cook event sorting to break ties between events with identical offsets
   */
  ordinal: number;
  /** The farthest down the page the user got */
  pageMaxScrollDepthPercent: number;
  /** signals this is the first page in the session */
  isEntryPage: boolean;
  /** Denormalized page vars */
  pageVars: vars.Var[];
  /** any errors associated with this event, such as var parsing, rate-limiting, etc. */
  errors: cookerr.Err[];
  /** defined_event_id is the id of the most specific matching user configured Defined Event. */
  definedEventId: string;
  /** additional matching events, not indexed or used in aggregations */
  additionalMatchingDefinedIds: string[];
  captureSource: CaptureSource | null;
  /** Id of the "paige" defined page, that this event occurred on */
  pageDefId: number;
  /** The ID of the event target. On web, this is the "fsid" identifying the node in the current document. On mobile, this is an alias for view_id. */
  fsId: protobuf.uint64;
  /** The events of a dx object (initially metric or segment) that an event can be matched on. */
  dxObjectMatchingEvents: DxObjectMatchingEvent[];
  /**
   * The exact time the event's associated raw event was ingested into the system. If this event comes from multiple raw
   *  events, this will be the latest ingestion time.
   */
  ingestionTime: protobuf.timestamp | null;
  inSessionPredictions: InSessionPrediction[];
}

export namespace Event {
  /** Type specific details. For types without additional details, no details will be set. */
  export enum details {
    loadDetails = 2,
    requestDetails = 3,
    customDetails = 4,
    uservarDetails = 5,
    lowMemoryDetails = 20,
    pagevarDetails = 21,
    pinchGestureDetails = 24,
    exceptionDetails = 26,
    navigateDetails = 27,
    datalossDetails = 28,
    watchedElementDetails = 29,
    pageViewDetails = 30,
    consoleMessageDetails = 32,
    consentDetails = 35,
    fidDetails = 39,
    clsDetails = 40,
    keepDetails = 42,
    appRestartDetails = 45,
    inpDetails = 46,
    suspiciousActivityDetails = 52
  }

  /** Type specific details. For types without additional details, no details will be set. */
  export function details_oneof(m: Event): { opt: details.appRestartDetails, val: EventAppForcedRestartDetails } | { opt: details.clsDetails, val: EventCumulativeLayoutShiftDetails } | { opt: details.consentDetails, val: EventConsentDetails } | { opt: details.consoleMessageDetails, val: EventConsoleMessageDetails } | { opt: details.customDetails, val: EventCustomDetails } | { opt: details.datalossDetails, val: EventDatalossDetails } | { opt: details.exceptionDetails, val: EventExceptionDetails } | { opt: details.fidDetails, val: EventFirstInputDelayDetails } | { opt: details.inpDetails, val: EventInteractionToNextPaintDetails } | { opt: details.keepDetails, val: EventKeep } | { opt: details.loadDetails, val: EventLoadDetails } | { opt: details.lowMemoryDetails, val: EventLowMemoryDetails } | { opt: details.navigateDetails, val: EventNavigateDetails } | { opt: details.pageViewDetails, val: EventPageViewDetails } | { opt: details.pagevarDetails, val: EventPageVarDetails } | { opt: details.pinchGestureDetails, val: EventPinchGestureDetails } | { opt: details.requestDetails, val: EventRequestDetails } | { opt: details.suspiciousActivityDetails, val: EventSuspiciousActivityDetails } | { opt: details.uservarDetails, val: EventUservarDetails } | { opt: details.watchedElementDetails, val: EventWatchedElementDetails } | null {
    if (m.loadDetails != null) { return { opt: details.loadDetails, val: m.loadDetails } }
    if (m.requestDetails != null) { return { opt: details.requestDetails, val: m.requestDetails } }
    if (m.customDetails != null) { return { opt: details.customDetails, val: m.customDetails } }
    if (m.uservarDetails != null) { return { opt: details.uservarDetails, val: m.uservarDetails } }
    if (m.lowMemoryDetails != null) { return { opt: details.lowMemoryDetails, val: m.lowMemoryDetails } }
    if (m.pagevarDetails != null) { return { opt: details.pagevarDetails, val: m.pagevarDetails } }
    if (m.pinchGestureDetails != null) { return { opt: details.pinchGestureDetails, val: m.pinchGestureDetails } }
    if (m.exceptionDetails != null) { return { opt: details.exceptionDetails, val: m.exceptionDetails } }
    if (m.navigateDetails != null) { return { opt: details.navigateDetails, val: m.navigateDetails } }
    if (m.datalossDetails != null) { return { opt: details.datalossDetails, val: m.datalossDetails } }
    if (m.watchedElementDetails != null) { return { opt: details.watchedElementDetails, val: m.watchedElementDetails } }
    if (m.pageViewDetails != null) { return { opt: details.pageViewDetails, val: m.pageViewDetails } }
    if (m.consoleMessageDetails != null) { return { opt: details.consoleMessageDetails, val: m.consoleMessageDetails } }
    if (m.consentDetails != null) { return { opt: details.consentDetails, val: m.consentDetails } }
    if (m.fidDetails != null) { return { opt: details.fidDetails, val: m.fidDetails } }
    if (m.clsDetails != null) { return { opt: details.clsDetails, val: m.clsDetails } }
    if (m.keepDetails != null) { return { opt: details.keepDetails, val: m.keepDetails } }
    if (m.appRestartDetails != null) { return { opt: details.appRestartDetails, val: m.appRestartDetails } }
    if (m.inpDetails != null) { return { opt: details.inpDetails, val: m.inpDetails } }
    if (m.suspiciousActivityDetails != null) { return { opt: details.suspiciousActivityDetails, val: m.suspiciousActivityDetails } }
    return null;
  }
}

export interface DxObjectMatchingEvent {
  /** Hash of event component of a metric or segment */
  componentEventId: string;
}

export interface CaptureSource {
  /** Describes the point where the event entered fullstory, such as "fs.event" or a server event http URL */
  entrypoint: string;
  /** Describes where the event comes from, such as "server", "DOM", or "android sdk" */
  origin: string;
  /** The integration that generated the event, if any. For example, "zendesk". */
  integration: string;
  /** Arbitrary value that can be added by the sender of the event (the customer). Used for their tracking/debugging. */
  customAnnotations: { [key: string]: string };
}

/** Wrapper message around a slice of events and augmenting data. Extended with behavior in cook.go. */
export interface EventsList {
  events: Event[];
  eventsTruncated: number;
}

/** Data derived from raw events during the cook, potentially annotated with data from other sources, such as Cloracle cluster IDs. */
export interface DerivedData {
  eventsList: EventsList | null;
  duration: protobuf.duration | null;
  deadSpaces: PageDeadSpace[];
  /** Whether or not the page is closed, if true, we have seen all of the events */
  closed: boolean;
  /** Whether the page relies on internal scrolling versus document scrolling */
  isInternalScrolling: boolean;
  /** Derived ("safe") page URL, taking into account the org's current querystring blocking rules. */
  pageUrl: string;
  /** Derived ("safe") referrer URL, taking into account the org's current querystring blocking rules. */
  referrer: string;
  /**
   * The timestamp of the last raw event that was an input to the cook that produced this data.  In other words,
   * this DerivedData is up to date as of this timestamp.  This can be used to detect when a cook would be
   * redundant and thus can be skipped.
   */
  lastRawEvent: protobuf.timestamp | null;
  /** The sequence number of the next bundle to be processed in a future cook. */
  nextBundle: protobuf.int64;
  /** Timeline of states like page focus, blur, etc. Used for web multitab UI. */
  lifecycleStates: schema.PageLifecycleTransition[];
  /** Indicates whether lethe failed to redact a page. *Might* indicate all cooked & raw events have been wiped. */
  wasUnredactable: boolean;
  /** Indicates whether the raw events were truncated at the bundle boundary when loading bundles from Bigtable during the cook. */
  rawEventsTruncated: boolean;
}

/** PageCookMetadata contains metadata associated with when the page was cooked. Can persist across multiple cooks. */
export interface PageCookMetadata {
  /**
   * The time that the final cook for the page occurred. Also serves a flag indicating that the page has experienced
   * a final cook.
   */
  finalCookTime: protobuf.timestamp | null;
}

export enum EventType {
  EVENT_TYPE_INVALID = 0,
  EVENT_TYPE_NAVIGATE = 1,
  EVENT_TYPE_LOAD = 2,
  EVENT_TYPE_CLICK = 3,
  /** @deprecated */
  EVENT_TYPE_FOCUS = 4,
  EVENT_TYPE_CHANGE = 5,
  /** @deprecated */
  EVENT_TYPE_TAP = 6,
  EVENT_TYPE_MOUSE_THRASH = 7,
  EVENT_TYPE_FORMABANDON = 8,
  EVENT_TYPE_ELEM_SEEN = 9,
  EVENT_TYPE_REQUEST = 10,
  /** @deprecated */
  EVENT_TYPE_LONG_CLICK = 11,
  /** @deprecated */
  EVENT_TYPE_UNHANDLED_CLICK = 12,
  /** @deprecated */
  EVENT_TYPE_UNHANDLED_LONG_CLICK = 13,
  EVENT_TYPE_BACKGROUNDED = 14,
  EVENT_TYPE_CRASHED = 15,
  EVENT_TYPE_CUSTOM = 16,
  EVENT_TYPE_USERVAR = 17,
  EVENT_TYPE_CUSTOM_ERROR = 18,
  EVENT_TYPE_USERVAR_ERROR = 19,
  EVENT_TYPE_REDACTED = 20,
  EVENT_TYPE_DATALOSS = 21,
  EVENT_TYPE_KEYBOARD_OPEN = 22,
  EVENT_TYPE_KEYBOARD_CLOSE = 23,
  EVENT_TYPE_LOW_MEMORY = 24,
  EVENT_TYPE_PAGEVAR = 25,
  EVENT_TYPE_PAGEVAR_ERROR = 26,
  EVENT_TYPE_ELEM_SEEN_ERROR = 27,
  EVENT_TYPE_PINCH_GESTURE = 28,
  EVENT_TYPE_EXCEPTION = 29,
  EVENT_TYPE_HIGHLIGHT = 30,
  EVENT_TYPE_PAGEVIEW = 32,
  EVENT_TYPE_COPY = 33,
  EVENT_TYPE_PASTE = 34,
  EVENT_TYPE_CONSOLE_MESSAGE = 35,
  /** for rate limit error click events */
  EVENT_TYPE_CLICK_ERROR = 36,
  /** for rate limit error console message events */
  EVENT_TYPE_CONSOLE_MESSAGE_ERROR = 37,
  EVENT_TYPE_CONSENT = 38,
  /** for rate limit error paste events */
  EVENT_TYPE_PASTE_ERROR = 39,
  /** for rate limit error navigate events */
  EVENT_TYPE_NAVIGATE_ERROR = 40,
  /** for rate limit error pageview events */
  EVENT_TYPE_PAGEVIEW_ERROR = 41,
  EVENT_TYPE_FIRST_INPUT_DELAY = 42,
  EVENT_TYPE_CUMULATIVE_LAYOUT_SHIFT = 43,
  /** Represents a keep signal satisfying configured rules for FS.Focus users */
  EVENT_TYPE_KEEP = 44,
  EVENT_TYPE_ELEMVAR_ERROR = 45,
  EVENT_TYPE_APP_FORCED_RESTART = 46,
  EVENT_TYPE_INTERACTION_TO_NEXT_PAINT = 47,
  EVENT_TYPE_SUSPICIOUS_ACTIVITY = 51
}

/**
 * Modifier values to be used within the event modifiers map (the numerical enum value is used as the key).
 * TODO(jgw): Move these out into their own fields, rather than jamming them into this weird int->int map.
 */
export enum EventModifier {
  EVENT_MODIFIER_INVALID = 0,
  EVENT_MODIFIER_DEAD_CLICK = 1,
  EVENT_MODIFIER_FRUSTRATED_CLICK = 2,
  EVENT_MODIFIER_ERROR_CLICK = 3,
  EVENT_MODIFIER_SUSPICIOUS_EVENT = 4,
  EVENT_MODIFIER_THUMB_SENTIMENT = 5,
  EVENT_MODIFIER_LONG_CLICK = 6,
  EVENT_MODIFIER_UNHANDLED_CLICK = 7
}

/** Modifier values for error clicks */
export enum ErrorClickCode {
  ERROR_CLICK_CODE_INVALID = 0,
  ERROR_CLICK_CODE_UNKNOWN = 1,
  ERROR_CLICK_CODE_CONSOLE = 2,
  ERROR_CLICK_CODE_EXCEPTION = 3
}

/** LOAD event specific details. */
export interface EventLoadDetails {
  domContentTime: protobuf.duration | null;
  firstPaintTime: protobuf.duration | null;
  eventTime: protobuf.duration | null;
  largestPaintTime: protobuf.duration | null;
  /**
   * TimeToInteractive measures the time from when the page starts loading to when its
   * main sub-resources have loaded and it is capable of reliably responding to user input quickly.
   */
  timeToInteractive: protobuf.duration | null;
  /**
   * TotalBlockingTime measures the total amount of time between First Contentful Paint (FCP)
   * and Time to Interactive (TTI) where the main thread was blocked for long enough to prevent
   * input responsiveness (> 50ms).
   */
  totalBlockingTime: protobuf.duration | null;
  /**
   * TimeToFirstByte measures the time between the request for a resource and when the first byte
   * of a response begins to arrive.
   */
  timeToFirstByte: protobuf.duration | null;
}

/** FirstInputDelay event specific details. */
export interface EventFirstInputDelayDetails {
  delay: protobuf.duration | null;
}

/** CumulativeLayoutShift event specific details. */
export interface EventCumulativeLayoutShiftDetails {
  score: number;
}

/**
 * InteractionToNextPaint assesses a page's overall responsiveness to user interactions
 * by observing the latency of all click, tap, and keyboard interactions that occur
 * throughout the lifespan of a user's visit to a page. The final INP value is the
 * longest interaction observed, ignoring outliers.
 */
export interface EventInteractionToNextPaintDetails {
  timing: protobuf.duration | null;
  /**
   * The type of the interaction that triggered the event.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEventTiming#events_exposed for all possible events.
   */
  eventName: string;
}

/** REQUEST event specific details. */
export interface EventRequestDetails {
  method: string;
  url: string;
  status: number;
  duration: protobuf.duration | null;
}

/** CUSTOM event specific details. */
export interface EventCustomDetails {
  /** custom event name */
  name: string;
  /** custom event vars */
  vars: vars.Var[];
  /**
   * list of erroring fields
   * TODO(jgw): Remove after migration
   * 
   * @deprecated
   */
  varErrors: cookerr.Err[];
  /** api source (e.g. zapier, segment, direct api call) */
  apiSource: string;
  /** platform (denormalized from PageType field on the containing Page) */
  platform: schema.PageType;
}

/** CONSENT event specific details. */
export interface EventConsentDetails {
  /** the state of user consent */
  consent: boolean;
  /** consent scope page = 0, document = 1 */
  scope: clientapi.ConsentScope;
  /** source type of the consent */
  sourceType: SourceType;
}

export enum SourceType {
  /** Report the existing value for the user's consent state */
  SYS_REPORTCONSENT = 0,
  /** Set a new value for the user's consent state */
  SYS_SETCONSENT = 1
}

/** USERVAR event specific details. */
export interface EventUservarDetails {
  /** custom event vars */
  vars: vars.Var[];
  /**
   * list of erroring fields
   * TODO(jgw): Remove after migration
   * 
   * @deprecated
   */
  varErrors: cookerr.Err[];
}

/** PAGEVAR event specific details. */
export interface EventPageVarDetails {
  /** The vars as they came in from the API */
  vars: vars.Var[];
  /**
   * Errors and the respective fields
   * TODO(jgw): Remove after migration
   * 
   * @deprecated
   */
  varErrors: cookerr.Err[];
  /** Whether or not this event is an unset event */
  isUnset: boolean;
}

export enum PinchGestureType {
  PINCH_SCALE_INVALID = 0,
  /** pinch leading to a scale in */
  PINCH_SCALE_IN = 1,
  /** pinch leading to a scale out */
  PINCH_SCALE_OUT = 2
}

/** PINCH_GESTURE event specific details. */
export interface EventPinchGestureDetails {
  pinchGestureType: PinchGestureType;
  /**
   * change in the visual viewport after a finger pinch
   * if the change > 1.0, it implies scale in
   * if the change < 1.0, it implies scale out
   * if the change is exactly 1.0, it means a failed finger pinch
   */
  visualScaleChange: number;
  /**
   * Scale determines the overall page Scale.
   * It is the ratio of the layout viewport dimensions to visual viewport dimensions
   * When the page is scaled out to max, the scale 1.0 and greater than 1.0 otherwise
   */
  scale: number;
  /**
   * change in the initial double touch distance after a finger pinch in the same direction
   * if the change > 1.0, it implies pinching out
   * if the change < 1.0, it implies pinching in
   */
  touchDistanceChange: number;
}

/** Exception. */
export interface EventExceptionDetails {
  /** The source file that produced the exception */
  sourceFile: string;
  /** The number of times that this exception fired within a given window (useful for batching bursts of exceptions fired). */
  count: number;
  /** Whether the exception is caught or not. */
  caught: boolean;
}

export interface EventAppForcedRestartDetails {
  orgId: string;
  userId: string;
  sessionId: string;
  pageId: string;
  hasClientsideIds: boolean;
  elapsedMillis: protobuf.uint64;
}

/** Target of the event. */
export interface EventTarget {
  /**
   * deprecated, the full selector path to the event's target element
   * 
   * @deprecated
   */
  selectorDeprecated: string;
  /** the full selector path (in a structured form) to the event's target element. */
  selector: selectors.SelectorPart[];
  /** the text content of the event's target element (or value in the case of input change) */
  text: string;
  /** bounds of the event, mouse coordinates and element measurements */
  bounds: EventTargetBounds | null;
  /** Nth child for an associated target element within it's parent, only set for clicks currently */
  nthChild: number;
  /** target text is empty because it was completely masked. */
  masked: boolean;
  /** named_element_id is the id of any matching user configured Named Element. */
  namedElementId: string;
  /** additional matching elements, not indexed or used in aggregations */
  additionalElementIds: string[];
  /** Supplemental path identifying this target precisely, as defined in prep.proto::Node. */
  indexPath: IndexPathElem[];
  /** Element properties set for the element interaction. */
  elementVars: vars.Var[];
  /**
   * Element property errors for the element interaction.
   * These exist explicitly in the event target (as opposed to the top level errors field)
   * to differentiate event specific errors and target element property errors.
   */
  elementVarErrors: cookerr.Err[];
  /**
   * Ordered list of named element <-> var connections.
   * Entries are only present for named elements that are not connected to all element vars set above.
   * The list is ordered by connection depth, shallowest connections first.
   * Named elements that appear in the list have the applicable property connections
   * in their entry as well as any property connections in preceding entries.
   * For any tagged named elements that are not present in this list, it can
   * be assumed that all element vars are applicable.
   */
  elementVarConnections: ElementVarConnections[];
  /**
   * Ids for element property rules that contributed element properties to this
   * event target. These can be correlated to entries in element_vars by
   * retrieving the rule definitions and matching the name and type fields.
   * This field is meant to power the FSTA DQM product feature only, and is not
   * intended for external consumption.
   */
  elementVarRuleIds: string[];
}

/** A connection between named element ids and elemenet scoped vars. */
export interface ElementVarConnections {
  namedElementIds: string[];
  connections: ElementVarConnections.ElementVar[];
}

/** A connection between named element ids and elemenet scoped vars. */
export namespace ElementVarConnections {
  export interface ElementVar {
    name: string;
    type: vars.Type;
  }
}

/** These types are based on the Performance Navigation Timing API https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming/type */
export enum NavigationReason {
  NAVIGATION_REASON_UNKNOWN = 0,
  NAVIGATION_REASON_NAVIGATE = 1,
  NAVIGATION_REASON_RELOAD = 2,
  NAVIGATION_REASON_BACK_FORWARD = 3,
  NAVIGATION_REASON_PRERENDER = 4
}

/** NAVIGATE event specific details. */
export interface EventNavigateDetails {
  reason: NavigationReason;
  /** Selector for an internal element that's being scrolled vs document scroll */
  scrollContainerSelector: string;
  /**
   * EXPERIMENTAL - USED FOR SELECT ORGS
   * A snapshot of what the DOM / View tree was at the time of the navigate. For now, this is the target text of the
   * tree.
   */
  treeSnapshot: string;
}

export enum DatalossType {
  /** Unknown or unspecified type. */
  DATALOSS_TYPE_NONE = 0,
  /** Payment card number (credit, debit, etc). */
  DATALOSS_TYPE_PAYMENT_CARD = 1,
  /** Email address. */
  DATALOSS_TYPE_EMAIL = 2,
  /** US Social Security number. */
  DATALOSS_TYPE_SSN = 3,
  /** A string that looks like a password */
  DATALOSS_TYPE_PASSWORD = 4
}

export enum DatalossSource {
  /** Unknown or unspecified source. */
  DATALOSS_SOURCE_UNKNOWN = 0,
  /**
   * Data found in UI element.
   * The element will be specified in the target selector field.
   * Origin will be empty for text content, or the name for attribute values.
   */
  DATALOSS_SOURCE_ELEMENT = 1,
  /**
   * Data found in user-input element.
   * Origin will be unspecified, but the element will be specified in the target selector field.
   */
  DATALOSS_SOURCE_INPUT_ELEMENT = 2,
  /**
   * Data found in navigation URL.
   * Origin will be of the form "query:[name]" or "hash:[name]", identifying the location of the named query or hash
   * parameter containing the suspected value.
   */
  DATALOSS_SOURCE_NAVIGATE_URL = 3,
  /**
   * Data found in network request URL.
   * Same origin as for navigation URL.
   * The req_url field will contain the parsed request URL, with the suspected-sensitive part masked.
   */
  DATALOSS_SOURCE_NETWORK_URL = 4,
  /**
   * Data found in network request/response header.
   * The origin field will contain the header name.
   * The req_url field will contain the parsed request URL.
   */
  DATALOSS_SOURCE_NETWORK_REQUEST_HEADER = 5,
  DATALOSS_SOURCE_NETWORK_RESPONSE_HEADER = 6,
  /**
   * Data found in network request/response body.
   * The origin field will contain the key of the suspected value, if available (JSON/XML key paths, etc).
   * The req_url field will contain the parsed request URL.
   */
  DATALOSS_SOURCE_NETWORK_REQUEST_BODY = 7,
  DATALOSS_SOURCE_NETWORK_RESPONSE_BODY = 8,
  /**
   * Data found in exceptions, perf data, etc.
   * Origin will contain the source function, when available.
   * The req_url field will contain the source file, and the origin will contain the line number, when available.
   */
  DATALOSS_SOURCE_EXCEPTION = 9,
  /**
   * Data found in console logs.
   * Origin will contain the source function, when available.
   * The req_url field will contain the source file, and the origin will contain the line number, when available.
   */
  DATALOSS_SOURCE_LOG = 10
}

/** DATALOSS event specific details. */
export interface EventDatalossDetails {
  /** Specifies the type of data discovered (payment card, email, etc). */
  type: DatalossType;
  /** Specifies the source of the data (navigation url, element, etc). */
  source: DatalossSource;
  /** Source-specific value that gives extra detail on the data origin. */
  origin: string;
  /**
   * For network request sources, specifies the associated request url.
   * For log / exception sources, specifies the source file url.
   */
  requestUrl: string;
}

export enum WatchedElementType {
  WATCHED_ELEMENT_TYPE_UNKNOWN = 0,
  WATCHED_ELEMENT_TYPE_RENDERED = 1,
  WATCHED_ELEMENT_TYPE_VISIBLE = 2,
  WATCHED_ELEMENT_TYPE_END = 3
}

/** SEEN event specific details. */
export interface EventWatchedElementDetails {
  type: WatchedElementType;
  renderDuration: protobuf.duration | null;
  visibleDuration: protobuf.duration | null;
  /**
   * The type of the WatchedElement at the point we consider the start of the WatchedElement. It could either be
   * WATCHED_ELEMENT_TYPE_RENDERED or WATCHED_ELEMENT_TYPE_VISIBLE. start_type along with start_time are provided so
   * that indexing has all the information it needs on the WATCHED_ELEMENT_TYPE_END event to index the event.
   */
  startType: WatchedElementType;
  startTime: protobuf.int64;
  /**
   * A unique ID that can be used to correlate different watched element types to the same event.
   * This value is only unique within the context of a page and is used at index time to tie end
   * and start events together.
   */
  startId: string;
  /**
   * Indicates that the event was not rate limited, indicating that any number of these could be in the cook.
   * Downstream systems like indexing may choose to ignore this event.
   */
  isUnlimited: boolean;
}

/** Bounds for the target element. */
export interface EventTargetBounds {
  /** coordinates of the mouse at the time of the event */
  mouseCoordinates: Coordinates | null;
  /** coordinates of the element involved in the event */
  elementCoordinates: Coordinates | null;
  /** size of the element involved in the event */
  elementSize: Size | null;
}

/** Console statistics for the event. */
export interface EventConsoleStats {
  numInfos: number;
  numWarnings: number;
  numErrors: number;
}

export interface Coordinates {
  x: number;
  y: number;
}

export interface Size {
  width: number;
  height: number;
}

/** LOW_MEMORY event specific details. */
export interface EventLowMemoryDetails {
  availableMemory: protobuf.int64;
  maxMemory: protobuf.int64;
}

/** PageView event specific details. */
export interface EventPageViewDetails {
  startTime: protobuf.int64;
  endTime: protobuf.int64;
  /** optional pageName assigned using the setVars API */
  pageName: string;
  duration: protobuf.duration | null;
  activeDuration: protobuf.duration | null;
  inactiveDuration: protobuf.duration | null;
  /** Selector for an internal element that's being scrolled vs document scroll */
  scrollContainerSelector: string;
  isTrailing: boolean;
}

export enum ConsoleMessageLevelType {
  CONSOLE_MESSAGE_LEVEL_TYPE_UNKNOWN = 0,
  CONSOLE_MESSAGE_LEVEL_TYPE_ERROR = 1
}

export interface EventConsoleMessageDetails {
  type: ConsoleMessageLevelType;
}

/**
 * One element of node's "index path", used to identify it more precisely than an abstract selector.
 * 
 * An index path will start with a unique id if one is available. Subsequent elements in the path will
 * be identified by their type and index, creating an unambiguous path to a specific node.
 */
export interface IndexPathElem {
  /** The type of this element ('tag' in the web implementation). */
  type: string;
  /** The element's index among its siblings of the same type. */
  index?: number;
  /** The element's unique id, if there is one. */
  id?: string;
}

/**
 * One element of node's "index path", used to identify it more precisely than an abstract selector.
 * 
 * An index path will start with a unique id if one is available. Subsequent elements in the path will
 * be identified by their type and index, creating an unambiguous path to a specific node.
 */
export namespace IndexPathElem {
  export enum details {
    /** The element's index among its siblings of the same type. */
    index = 2,
    /** The element's unique id, if there is one. */
    id = 3
  }

  export function details_oneof(m: IndexPathElem): { opt: details.id, val: string } | { opt: details.index, val: number } | null {
    if (m.index != null) { return { opt: details.index, val: m.index } }
    if (m.id != null) { return { opt: details.id, val: m.id } }
    return null;
  }
}

export interface EventKeep {
  /** The type of the configured keep rule */
  type: KeepRuleType;
}

/** KeepRuleType represents the possible categories of keep rules that can be configured for orgs */
export enum KeepRuleType {
  KEEP_RULE_INVALID = 0,
  KEEP_RULE_ELEMENT = 1,
  KEEP_RULE_URL = 2,
  KEEP_RULE_DWELL = 3
}

export interface InSessionPrediction {
  /** when the prediction occurred */
  occurredOffset: protobuf.int64;
  /** flow_completion-v0 */
  model: string;
  /** prob, score etc.... */
  score: number;
}

/** Suspicious Activity can have high level type like fraud or automation */
export enum SuspiciousActivityType {
  SUSPICIOUS_ACTIVITY_TYPE_INVALID = 0,
  SUSPICIOUS_ACTIVITY_FRAUD = 1,
  SUSPICIOUS_ACTIVITY_AUTOMATION = 2
}

/**
 * SuspiciousSignalCategory defines the exact type of suspicious behavior
 * that is being detected, such as credential fraud or autofill.
 */
export enum SuspiciousActivityCategory {
  SUSPICIOUS_ACTIVITY_CATEGORY_INVALID = 0,
  SUSPICIOUS_ACTIVITY_CATEGORY_SQL_INJECTION = 1,
  SUSPICIOUS_ACTIVITY_CATEGORY_XSS = 2,
  SUSPICIOUS_ACTIVITY_CATEGORY_CREDENTIAL_PAIR = 3,
  SUSPICIOUS_ACTIVITY_CATEGORY_MULTIPLE_EMAILS = 4,
  SUSPICIOUS_ACTIVITY_CATEGORY_VENDOR_IP = 5,
  SUSPICIOUS_ACTIVITY_CATEGORY_IDLE_TIMEOUT = 6
}

export interface EventSuspiciousActivityDetails {
  /**
   * The type of the suspicious activity
   * which is either fraud signal or a bot or automation signal
   */
  type: SuspiciousActivityType;
  /** Category defines the exact type of suspicious behavior */
  category: SuspiciousActivityCategory;
}
